import { render } from "./CompaniesSearch.vue?vue&type=template&id=d0e790aa"
import script from "./CompaniesSearch.vue?vue&type=script&lang=js"
export * from "./CompaniesSearch.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__